/**
 * Format for passing dates to the Ennismore API.
 */
export const API_DATE_FORMAT = 'YYYY-MM-DD';
